if (document.location.pathname == "/pages/contacto") {
  var intervalInputToCheck = setInterval(function(){
    console.log("checkbox")
    if( jQuery("#template--23034087276832__form-contact-field-6").attr("type") == "text" ) {
      jQuery("#template--23034087276832__form-contact-field-6").attr("type", "checkbox")
    } else {
      clearInterval(intervalInputToCheck)
    }
  }, 1000)

  jQuery('input[name="contact[Nombre]"]').attr("placeholder", "Nombres")
  jQuery('input[name="contact[apellido]"]').attr("placeholder", "Apellidos")
  jQuery('input[name="contact[email]"]').attr("placeholder", "Correo electrónico")
  jQuery('textarea[name="contact[Mensaje]"]').attr("placeholder", "Mensaje")
}
if (document.location.pathname == "/") {
  var timeoutNewsletter = setTimeout(function(){
    jQuery('.newsletter input[name="contact[email]"]').attr("placeholder", "Ingresa tu Correo electrónico")
    jQuery('.footer-col--newsletter input[name="contact[email]"]').attr("placeholder", "Ingresa tu Correo electrónico")
  }, 1000)
}